import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OtherStaffDataModel } from 'data/otherStaff/otherStaff.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: OtherStaffDataModel;
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: { totalCount: 0, page: 0, limit: 0, data: [] },
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<OtherStaffDataModel>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: { totalCount: 0, page: 0, limit: 0, data: [] },
  status: 'error',
});

const otherstaffSlice = createSlice({
  name: 'otherstaff',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default otherstaffSlice;
